import {
  sendEmailTransmission as publicSendEmailTransmission,
  getEmailTransmission as publicGetEmailTransmission,
  queryEmailTransmissions as publicQueryEmailTransmissions,
  typedQueryEmailTransmissions as publicTypedQueryEmailTransmissions,
  deleteEmailTransmission as publicDeleteEmailTransmission,
} from './emails-transmissions-v1-email-transmission-email-transmissions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  EmailTransmissionQuery,
  EmailTransmissionsQueryBuilder,
  typedQueryEmailTransmissions as universalTypedQueryEmailTransmissions,
} from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';
import { onEmailTransmissionCreated as publicOnEmailTransmissionCreated } from './emails-transmissions-v1-email-transmission-email-transmissions.public.js';
import { onEmailTransmissionDeleted as publicOnEmailTransmissionDeleted } from './emails-transmissions-v1-email-transmission-email-transmissions.public.js';
import { onEmailTransmissionUpdated as publicOnEmailTransmissionUpdated } from './emails-transmissions-v1-email-transmission-email-transmissions.public.js';

function customQueryEmailTransmissions(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryEmailTransmissions(httpClient)(),
    typedQueryFunction: (query: EmailTransmissionQuery) =>
      publicTypedQueryEmailTransmissions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): EmailTransmissionsQueryBuilder;
  function overloadedQuery(
    query: EmailTransmissionQuery
  ): ReturnType<typeof universalTypedQueryEmailTransmissions>;
  function overloadedQuery(query?: EmailTransmissionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const sendEmailTransmission: MaybeContext<
  BuildRESTFunction<typeof publicSendEmailTransmission> &
    typeof publicSendEmailTransmission
> = /*#__PURE__*/ createRESTModule(publicSendEmailTransmission);
export const getEmailTransmission: MaybeContext<
  BuildRESTFunction<typeof publicGetEmailTransmission> &
    typeof publicGetEmailTransmission
> = /*#__PURE__*/ createRESTModule(publicGetEmailTransmission);
export const deleteEmailTransmission: MaybeContext<
  BuildRESTFunction<typeof publicDeleteEmailTransmission> &
    typeof publicDeleteEmailTransmission
> = /*#__PURE__*/ createRESTModule(publicDeleteEmailTransmission);
export const queryEmailTransmissions: MaybeContext<
  BuildRESTFunction<typeof customQueryEmailTransmissions> &
    typeof customQueryEmailTransmissions
> = /*#__PURE__*/ createRESTModule(customQueryEmailTransmissions);
/**
 * Triggered when an email transmission is created.
 */
export const onEmailTransmissionCreated: BuildEventDefinition<
  typeof publicOnEmailTransmissionCreated
> &
  typeof publicOnEmailTransmissionCreated = /*#__PURE__*/ createEventModule(
  publicOnEmailTransmissionCreated
);
/**
 * Triggered when an email transmission is deleted.
 */
export const onEmailTransmissionDeleted: BuildEventDefinition<
  typeof publicOnEmailTransmissionDeleted
> &
  typeof publicOnEmailTransmissionDeleted = /*#__PURE__*/ createEventModule(
  publicOnEmailTransmissionDeleted
);
/**
 * Triggered when an email transmission is updated.
 */
export const onEmailTransmissionUpdated: BuildEventDefinition<
  typeof publicOnEmailTransmissionUpdated
> &
  typeof publicOnEmailTransmissionUpdated = /*#__PURE__*/ createEventModule(
  publicOnEmailTransmissionUpdated
);

export {
  RecipientStatus,
  FailureReason,
  Type,
  Status,
  RejectionReason,
  SortOrder,
  WebhookIdentityType,
} from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';
export {
  EmailTransmission,
  EmailTransmissionTypeOptionsOneOf,
  EmailTransmissionStatusOptionsOneOf,
  Recipient,
  RecipientValueOneOf,
  MarketingOptions,
  RejectedOptions,
  GetLiveEmailTransmissionRequest,
  GetLiveEmailTransmissionResponse,
  GetDeletedEmailTransmissionRequest,
  GetDeletedEmailTransmissionResponse,
  QueryLiveEmailTransmissionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryLiveEmailTransmissionsResponse,
  CursorPagingMetadata,
  Cursors,
  QueryDeletedEmailTransmissionsRequest,
  QueryDeletedEmailTransmissionsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  SendEmailTransmissionRequest,
  SendEmailTransmissionResponse,
  AccountSuspendedErrorDetails,
  OutOfQuotaErrorDetails,
  GetEmailTransmissionRequest,
  GetEmailTransmissionResponse,
  QueryEmailTransmissionsRequest,
  QueryEmailTransmissionsResponse,
  DeleteEmailTransmissionRequest,
  DeleteEmailTransmissionResponse,
  Empty,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  EmailTransmissionCreatedEnvelope,
  EmailTransmissionDeletedEnvelope,
  EmailTransmissionUpdatedEnvelope,
  SendEmailTransmissionOptions,
  EmailTransmissionsQueryResult,
  EmailTransmissionsQueryBuilder,
  EmailTransmissionQuerySpec,
} from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';
export { utils } from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';
export {
  RecipientStatusWithLiterals,
  FailureReasonWithLiterals,
  TypeWithLiterals,
  StatusWithLiterals,
  RejectionReasonWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SendEmailTransmissionApplicationErrors,
  SendEmailTransmissionValidationErrors,
  DeleteEmailTransmissionApplicationErrors,
  CommonQueryWithEntityContext,
  EmailTransmissionQuery,
} from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';
